import {Link} from 'shared/pretty-easy-navigation/models';
import {NavigationContext} from '../navigation.context';

export const SiteMapLink = (_context: NavigationContext, role: string): Link => ({
    type: 'link',
    label: 'navigation.site_map',
    link: '/page/site-map' + (role ? '-' + role : ''),
    icon: 'navigation-link__site-map',
});